import { Outlet, useNavigate } from "react-router-dom";

export default function InventoryMain(props) {
  return (
    <>
      <Outlet />
    </>
  );
}
